import React, { Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, bool, number, shape,
} from 'prop-types'

import moment from 'moment'

import Icon from 'Pods/Shared/Icon/Icon'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function InboxItem({
  date, isRead, isReceived, body, conversation, user,
}) {
  return (
    <div className={classnames(
      'col-12',
      'feed-list__item',
      isRead && 'is-active',
      conversation.type === 'Promotions' && 'promotions-item',
    )}>
      <a href={`/profile/inbox/conversations/${conversation.id}`} className="message-link" />
      {user.username === 'Projects Assistant' ? (
        <Icon type={['fas', 'info-circle']} color="green-dark" className="avatar" notSpaced />
      ) : (
        <UserAvatar
          img={user.avatar.url}
          userName={user.username}
        />
      )}
      <div className="feed-item__info">
        <div className="feed-item__title">
          {user.username !== 'Projects Assistant' && (
            <Fragment>
              {isReceived ? 'From ' : 'To ' }
              <a href={user.profileUrl} className="link--primary-dark">{user.username}</a>:
            </Fragment>
          )}
          <span className="text-semibold"> {conversation.subject.replace(/PRODUCT SUPPORT: /, '')}</span>
        </div>
        <p className="u-mt10 u-mb0">{body.length > 90 ? `${body.substr(0, 90)}...` : body}</p>
        <div className="feed-item__secondary-info u-mt10">
          <span className="feed-item__date">{moment(date, 'X').format('Do MMM HH:mm')}</span>
          <span className="text-semibold">{conversation.type}</span>
        </div>
      </div>
    </div>
  )
}

InboxItem.propTypes = {
  date: number.isRequired,
  body: string.isRequired,
  isReceived: bool.isRequired,
  isRead: bool.isRequired,
  conversation: shape({
    id: string.isRequired,
    subject: string.isRequired,
    type: string.isRequired,
  }).isRequired,
  user: shape({
    username: string.isRequired,
    profileUrl: string.isRequired,
    avatar: shape({
      url: string,
    }).isRequired,
  }).isRequired,
}

export default InboxItem
